import './colour-scheme/colour-scheme.js';

navigator.serviceWorker?.register('/service-worker.js');
